export default "__VITE_ASSET__CwKLpgPD__"